<template>
	<section class="Calendar">
		<header>
			<A class="icon-chevron-right" @click="addMonth(-1)"></A>
			<span>{{ this.currentMonth.toLocaleDateString(undefined, { year: 'numeric', month: 'short' }) }}</span>
			<A class="icon-chevron-right" @click="addMonth(1)"></A>
		</header>
		<div class="dates" :style="{ '--startDay': startDay }">
			<span class="day" v-for="day in weekdays" :key="`day_${day}`">{{ day }}</span>
			<A class="date" v-for="d in dates" :disabled="!d.avaliable" :class="{ on: d.on }" :key="`date_${d.date}`" @click="onClickDate(d.date)">{{
				d.date
			}}</A>
		</div>
		<div v-if="type === 'datetime'" class="times">
			<Form :form="formTimes" :data="dataTimes" @change="onTimeChange" />
		</div>
		<div v-if="!instant" class="buttons">
			<Button @click="onSelectDate" :disabled="disabled">日時を確定する</Button>
		</div>
	</section>
</template>

<script>
	export default {
		props: {
			start: {
				type: Date,
				default: () => new Date()
			},
			period: {
				default: 30
			},
			type: {
				type: String,
				default: 'date'
			},
			instant: {
				type: Boolean,
				default: false
			}
		},
		// props: ['start', 'period', 'type'],
		data() {
			return {
				startMonth: null,
				currentMonth: null,
				currentDate: null,
				weekdays: '日月火水木金土',
				selectedTime: null
			};
		},
		beforeMount() {
			this.startMonth = new Date(new Date(new Date(this.start.getTime()).setDate(1)).setHours(0, 0, 0, 0));
			this.currentMonth = new Date(this.startMonth.getTime());
			this.currentDate = new Date(new Date(this.start.getTime()).setHours(0, 0, 0, 0));
		},
		methods: {
			onClickDate(date) {
				this.currentDate = new Date(new Date(this.currentMonth.getTime()).setDate(date));
				if (this.instant) {
					this.onSelectDate();
				}
			},
			addMonth(month) {
				this.currentMonth = new Date(new Date(this.currentMonth.getTime()).setMonth(this.currentMonth.getMonth() + month));
			},
			onTimeChange(key, value) {
				this.selectedTime = value;
				if (this.instant) {
					this.onSelectDate();
				}
			},
			onSelectDate() {
				this.$emit('select', [this.currentDate, this.selectedTime]);
			}
		},
		computed: {
			dates() {
				const count =
					new Date(new Date(new Date(this.currentMonth.getTime()).setMonth(this.currentMonth.getMonth() + 1)).setDate(-1)).getDate() + 1;
				return Array.from({ length: count }, (_, i) => {
					const start = new Date(this.start.getTime()).setHours(0, 0, 0, 0);
					const current = new Date(new Date(this.currentMonth.getTime()).setDate(i + 1));
					const end = new Date(new Date(this.start.getTime()).setDate(this.start.getDate() + +this.period));

					return { date: i + 1, avaliable: current >= start && current <= end, on: current.getTime() === this.currentDate.getTime() };
				});
			},
			startDay() {
				return new Date(new Date(new Date(this.currentMonth.getTime()).setMonth(this.currentMonth.getMonth())).setDate(1)).getDay();
			},
			startTime() {
				return 9;
			},
			endTime() {
				return 20;
			},
			formTimes() {
				return [
					{
						name: 'time',
						type: 'radio',
						title: 'title',
						multiselect: false,
						options: Array.from({ length: this.endTime - this.startTime }, (_, i) => ({
							label: `${(i + this.startTime + '').padStart(2, 0)}:00~${(i + this.startTime + 1 + '').padStart(2, 0)}:00`,
							value: i + this.startTime
						}))
					}
				];
			},
			dataTimes() {
				return {
					time: this.selectedTime
				};
			},
			disabled() {
				if (this.type === 'datetime') {
					return !(this.currentDate && this.selectedTime);
				} else {
					return !this.currentDate;
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	.Calendar {
		header {
			background-color: var(--clrTheme);
			color: white;
			padding: 1rem 2rem;
			display: flex;
			align-items: center;
			justify-content: center;

			.A {
				&:first-child {
					transform: scaleX(-1);
				}
			}

			span {
				margin: 0 1rem;
				min-width: 10rem;
				text-align: center;
			}
		}

		.dates {
			padding: 1rem 2rem;
			display: grid;
			grid-template-columns: repeat(7, 1fr);
			gap: 1rem;
			place-items: center;

			.day {
				&:first-of-type {
					color: lightcoral;
				}

				&:last-of-type {
					color: lightcoral;
				}
			}

			.date {
				display: flex;
				width: 3.2rem;
				height: 3.2rem;
				border-radius: 3.2rem;
				align-items: center;
				justify-content: center;

				&[disabled] {
					opacity: 0.25;
				}

				&:first-of-type {
					grid-column: calc(var(--startDay) + 1);
				}

				&:not(.avaliable) {
				}

				&.on {
					background-color: var(--clrTheme);
					color: white;
				}
			}
		}

		.times {
			padding: 1rem 2rem;
			border-top: solid 1px rgba(0, 0, 0, 0.1);

			/deep/ .Form {
				.form-group {
					.input-area {
					}
				}
			}
		}

		.buttons {
			display: flex;
			padding: 1rem 2rem;

			.Button {
				flex: 1;
			}
		}
	}
</style>
